import { compressImage, tooLargeRaw, fileExt, LONG_CACHE, PHOTO_MAX_SIDE } from "@/lib/image-compress";
import { supabase } from "@/integrations/supabase/client";

export type ActivityReportSource = "event" | "coffee";

export type ActivityReportRow = {
  id: string;
  author_user_id: string;
  source_type: string;
  source_id: string;
  photo_url: string;
  caption: string | null;
  hidden: boolean;
  created_at: string;
};

export const PHOTO_CONSENT_HINT =
  "Пожалуйста, не публикуй фото без согласия людей, которые на нём видны.";

const MAX_BYTES = 8 * 1024 * 1024;

export async function uploadActivityPhoto(file: File, userId: string): Promise<string> {
  if (!file.type.startsWith("image/")) throw new Error("Можно загружать только изображения");
  if (tooLargeRaw(file.size)) throw new Error("Размер файла не должен превышать 8 МБ");
  const blob = await compressImage(file, { maxSide: PHOTO_MAX_SIDE });
  if (blob.size > MAX_BYTES) throw new Error("Размер файла не должен превышать 8 МБ");
  const path = `${userId}/activity-reports/${Date.now()}.${fileExt(blob)}`;
  const { error } = await supabase.storage
    .from("marketplace")
    .upload(path, blob, { contentType: blob.type || "image/jpeg", cacheControl: LONG_CACHE });
  if (error) throw error;
  const { data } = supabase.storage.from("marketplace").getPublicUrl(path);
  return data.publicUrl;
}

export function timeAgoShort(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime();
  const min = Math.floor(diff / 60000);
  if (min < 1) return "только что";
  if (min < 60) return `${min} мин назад`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h} ч назад`;
  const d = Math.floor(h / 24);
  if (d < 30) return `${d} дн назад`;
  return new Date(iso).toLocaleDateString("ru-RU");
}
